module.exports = __webpack_public_path__ + "static/elturgard_chain_shirt_breastplate-993128e785f8d3a7bafaae5a115c6dce.png";